import { useState } from "react";
import { matchPath, useLocation } from "react-router";
import { ListViewCircleIcon } from "vega-icons";

import { useStore } from "@nanostores/react";
import { useDeviceWidth } from "@vega-core/hooks/useDeviceWidth";

import { ThemedButton } from "../../Buttons/ThemedButton";
import { $subNavigationItems } from "../../Navigation/Sidebar/SubNavigation.store";

import { MobileBreadcrumbsDrawer } from "./MobileBreadcrumbsDrawer";

type Props = {
  onNavigateBack?: () => void;
  backButtonText?: string;
};

export const MobileBreadcrumb = ({ onNavigateBack, backButtonText }: Props) => {
  const isMobile = !useDeviceWidth("md");

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const subNavItems = useStore($subNavigationItems);
  const { pathname } = useLocation();

  const isSubNavItemActive = (href: string) =>
    matchPath({ path: href, end: true }, pathname) !== null;

  if (!isMobile) {
    return null;
  }

  if (subNavItems.length === 0) {
    return null;
  }

  return (
    <>
      <ThemedButton
        className="pr-2 mt-2"
        dataTestId="breadcrumb-sub-nav-button"
        icon={<ListViewCircleIcon />}
        onClick={() => setIsDrawerOpen(true)}
        variant="secondary"
      />
      <MobileBreadcrumbsDrawer
        backButtonText={backButtonText}
        isOpen={isDrawerOpen}
        navigationItems={subNavItems.map((item) => ({
          ...item,
          isActive: isSubNavItemActive(item.href),
        }))}
        onNavigateBack={onNavigateBack}
        onOpenChange={setIsDrawerOpen}
      />
    </>
  );
};
